const DEFAULT_LOCAL_OPTIONS = {
  eventDistance: '50-miles',
  eventDate: 'all',
  eventHost: 'all',
  eventGroupOption: 'my-groups',
  sortBy: 'date',
  eventCategory: 'all-activities', // activityCategory is received in displayable format
  eventFilterNavTab: 'all',
  workspaceOnly: 'False',
};

const DEFAULT_VIRTUAL_OPTIONS = {
  virtualSubtype: 'all',
  virtualEventDate: 'all',
  virtualEventGroupOption: 'all',
  virtualSortBy: 'date',
  virtualTime: 'all',
  virtualEventCategory: 'all-activities', // activityCategory is received in displayable format
  virtualWorkspaceOnly: 'False',
};

export {DEFAULT_LOCAL_OPTIONS, DEFAULT_VIRTUAL_OPTIONS};
